export default __webpack_public_path__ + "static/media/eyeiconunfold.6caf6db3.svg";